import styled from "styled-components";

// theme is now fully typed
export const FooterWrapper = styled.div`
  display: flex;
  padding: 44px 16px 32px;
  background-color: var(--pou-bg-footer, #f2f2f2);
  -webkit-box-align: center;
  align-items: center;
  position: relative;
  flex-direction: column;
  gap: 10px;
  @media (max-width: 500px) {
    flex-direction: column;
  }

  .footer {
    &-logos {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px 0;
      font-size: 12px;
      color: #4b5563;
      gap: 8px;
      text-align: center;
      img {
        max-height: 48px;
        object-fit: contain;
      }
    }
    &-social {
      a {
        font-size: 21px;
        color: #188dcc;
      }
    }
    &-mobile-icon {
      position: absolute;
      right: 10px;
      top: 6px;
    }
    &-contact-us {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px 10px;
      margin-bottom: 10px;
      gap: 5px;
      color: #1f1f1f;
      &-icon {
        font-size: 21px;
        color: #188dcc;
      }
      &-text {
        color: #1f1f1f;
        margin-right: 20px;
        text-align: center;
        > span {
          font-weight: 700;
          padding-right: 10px;
        }
      }
      &-title {
        font-size: 1.6em;
        font-weight: 700;
        margin-bottom: 10px;
        color: #188dcc;
      }
    }
  }
`;
